<template>
  <div class="tabs" :style="{height: height+'px', ...style}">
    <div v-for="(item, i) in data" :key="i"
    :class="{ active: isActive(i) }"
    @click="handleTab(item, i)">
      {{item}}
    </div>
    <div class="right" v-if="isRightBtn">
      <el-button size="medium" round @click="() => { handleGenerateJson() }">生成JSON</el-button>
      <el-button size="medium" round @click="() => { handleSave('mode2') }">转为复杂模式</el-button>
      <el-button type="primary" size="medium" round @click="() => { handleSave('save') }">保存</el-button>
      <el-button type="success" size="medium" round @click="() => { handleSave('publish') }">发布</el-button>
      <el-button type="warning" size="medium" round @click="() => { goBack() }">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 50
    },
    activeColor: {
      type: String,
      default: '#000000'
    },
    tab: {
      type: Number,
      default: 0
    },
    isRightBtn: {
      type: Boolean,
      default: true
    },
    style: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  methods: {
    isActive(i) {
      return i === this.tab
    },
    handleTab(item, index) {
      this.tab = index
      this.$emit('on-tab', item, index)
    },
    handleSave(e) {
      this.$emit('on-save', e)
    },
    goBack() {
      this.$router.go(-1)
    },
    handleGenerateJson() {
      this.$emit('on-show-json')
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFF;
  border-bottom: 1px solid #fafafa;
  border-radius: 10px 10px 0 0;
  position: relative;
}
.tabs>div {
  padding: 0 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(92, 92, 92, 0.5);
  border-bottom: 2px solid transparent;
  box-sizing: border-box;
}
.tabs>div.active {
  font-weight: 700;
  color: #000000;
  border-bottom: 2px solid #000;
}
.right {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
